import SectionDivider from "./common/SectionDivider";
import {Carousel} from "flowbite-react";
import {aboutBanners} from "../data/banners";
import {useTranslation} from "react-i18next";
import {NewlineText} from "./common/NewlineText";

function AboutSection() {
    const { t } = useTranslation();
    return (
        <div className="section py-0 pt-12">
            <h1 data-aos="fade-right"
                data-aos-duration="300"
                className="text-primary-dark-color">{t("navigation_menu_about")}</h1>
            <SectionDivider/>
            <ImageSection/>
            <ContentSection/>
        </div>
    )
}

export default AboutSection;


const theme = {
    "root": {
        "base": "overflow-hidden no-scrollbar relative w-full mx-24 max-md:mx-4 max-w-screen-lg aspect-[2] max-md:aspect-[1]",
        "leftControl": "absolute left-0 top-0 flex h-full items-center justify-center px-4 focus:outline-none",
        "rightControl": "absolute right-0 top-0 flex h-full items-center justify-center px-4 focus:outline-none"
    }, "indicators": {
        "active": {
            "off": "bg-white/50", "on": "bg-white w-8"
        },
        "base": "h-1.5 w-6 rounded-sm",
        "wrapper": "absolute bottom-4 left-1/2 flex -translate-x-1/2 space-x-2"
    }, "item": {
        "base": "absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2",
        "wrapper": {
            "off": "w-full flex-shrink-0 transform cursor-default snap-center",
            "on": "w-full flex-shrink-0 transform cursor-grab snap-center"
        }
    }, "control": {
        "base": "w-0 h-0", "icon": "w-0 h-0",
    }, "scrollContainer": {
        "base": "flex h-full snap-mandatory overflow-y-hidden overflow-x-scroll scroll-smooth ease-out duration-800 rounded-[24px] md:rounded-[30px]",
        "snap": "snap-x"
    }
}

const ImageSection = () => {
    return (
        <Carousel theme={theme} slideInterval={5000}>
            {aboutBanners.map((banner, index) => (
                <img src={banner} alt="About us images" key={index} className="object-cover h-full"/>
            ))}
        </Carousel>
    )
}

const ContentSection = () => {
    const { t } = useTranslation();
    return (
        <div className="flex max-md:flex-col flex-row max-w-screen-lg max-lg:px-0 px-12 py-12 justify-between gap-8 pb-16">
            <div className="flex flex-col gap-2 items-start text-left max-lg:w-full w-4/6 space-y-2">
                <div className="font-bold text-xl">{t("about_content_title")}</div>
                <NewlineText className="max-md:text-sm text-base" text={t("about_content_1")}/>
                <div className="font-bold max-md:text-sm text-base">{t("about_content_2")}</div>
            </div>
            <div data-aos="fade-in"
                 data-aos-delay="200"
                 data-aos-duration="800"
                 className="flex items-center justify-center p-12 place-content-center
                            rounded-full bg-tertiary-light-color max-md:w-[240px] max-md:h-[240px] w-[310px] h-[310px] aspect-square">
                <div className="font-bold max-md:text-base text-xl text-left text-[#0C8D5F]">
                    {t("about_content_highlight")}
                </div>
            </div>
        </div>
    )
}
